import { c as _c } from "react/compiler-runtime";
import { PopoverClose } from "@radix-ui/react-popover";
import { useAppFromPath } from "@shared-utils/hooks/use-app-from-path";
import { languages } from "@shared-utils/localization/languages";
import { Globe } from "lucide-react";
import { ListItem } from "./list-item";
import { useLocalization } from "./localization-provider";
import { Button } from "./shadcn/button";
import { Label } from "./shadcn/label";
import { Popover, PopoverContent, PopoverTrigger } from "./shadcn/popover";
export const LanguageDropdown = () => {
  const $ = _c(16);
  const {
    setLanguage,
    language
  } = useLocalization();
  const app = useAppFromPath();
  const appLanguages = languages[app];
  if (!appLanguages || appLanguages.length === 0) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Globe size={18} strokeWidth={1.5} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== appLanguages || $[2] !== language) {
    t1 = appLanguages?.find(l => l.code === language)?.code;
    $[1] = appLanguages;
    $[2] = language;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <PopoverTrigger asChild={true}><Button variant="ghost" size="sm" className="flex flex-row items-center gap-1 pl-2">{t0}<span className="relative top-0.5 block font-bold">{t1}</span></Button></PopoverTrigger>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Label className="block p-2">{"Pick language"}</Label>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== appLanguages || $[8] !== language || $[9] !== setLanguage) {
    t4 = appLanguages?.map(listLanguage => <PopoverClose key={listLanguage.code} asChild={true}><ListItem className="flex flex-row items-center gap-2" onClick={() => setLanguage(listLanguage.code)} selected={language === listLanguage.code}><span className="font-bold">{`${listLanguage.code}`}</span><span>{"|"}</span><span>{listLanguage.name}</span></ListItem></PopoverClose>);
    $[7] = appLanguages;
    $[8] = language;
    $[9] = setLanguage;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <PopoverContent align="end" className="w-[150px] p-0">{t3}{t4}</PopoverContent>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t2 || $[14] !== t5) {
    t6 = <Popover>{t2}{t5}</Popover>;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};